import { useContext } from 'react'
import cx from 'classnames'

import { getPrice } from '@lib/helpers'
import { ShopContext } from '@lib/shop'
import { StringsContext } from '@lib/strings'

interface CartTotalProps {
  price: number
  className?: string
}

const CartTotal = ({ price, className }: CartTotalProps) => {
  const { currency, taxRate } = useContext(ShopContext)
  const strings = useContext(StringsContext)

  return (
    <div
      className={cx(
        'flex justify-between text-sm sm:text-base font-semibold',
        className
      )}
    >
      <span>{strings.cartTotal}</span>
      <span className="uppercase">
        {currency}
        {getPrice(price, taxRate)}
      </span>
    </div>
  )
}

export default CartTotal
